import actionTypes from '../../action-types'

export default (payload) => ({
  type: actionTypes.AUTHENTICATION.SET_ERROR_MESSAGE,
  payload,
})
